import { namespace } from '@common/Utils';
import { type IConfig } from '@interface/ICommon';
import { AppInit } from './appInit';
import Main, { loader } from './itemprice/Main';

namespace('window.nc.info.itemprice');
window.nc.info.itemprice = (config: IConfig) => {
    config.now = 'itemprice';
    AppInit('.itemprice-container', config, Main, loader);
};
